import React, { useState } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import HeadToHeadService from "../../services/HeadToHeadService";
import ShowPlayOff from "./ShowPlayOff";
import ShowPlayOff2 from "./ShowPlayOff2";
import ShowPlayOffFinal from "./ShowPlayOffFinal";
const H2HPlayOff = (props) => {
  const [playOffDataFirst, setPlayOffDataFirst] = useState({});
  const [playeOffSecond, setPlayeOffSecond] = useState({});
  const [playeOffFinal, setPlayeOffFinal] = useState({});
  const [playOffMatch1, setPlayOffMatch1] = useState(false);
  const [playOffMatch2, setPlayOffMatch2] = useState(false);

  const [playOffMatch3, setPlayOffMatch3] = useState(false);
  const [playOffMatch4, setPlayOffMatch4] = useState(false);
  const [playOffMatch5, setPlayOffMatch5] = useState(false);

  const [group1Rank2Data, setGroup1Rank2Data] = useState({});
  const [group1Rank3Data, setGroup1Rank3Data] = useState({});

  const [group2Rank3Data, setGroup2Rank3Data] = useState({});
  const [group2Rank2Data, setGroup2Rank2Data] = useState({});

  const [rankingData, setRankingData] = useState({});

  const [isPlayOffModalOpen, setIsPlayOffModalOpen] = useState(false);
  const [isPlayOffModalOpen2, setIsPlayOffModalOpen2] = useState(false);
  const [isPlayOffModalOpenFinal, setIsPlayOffModalOpenFinal] = useState(false);

  const [roundDetails, setRoundDetails] = useState({});
  const handlePlayOffShow = (playOffNumber) => {
    HeadToHeadService.getPlayOffdata(playOffNumber).then((result) => {
      if (result.status === 200) {
        setPlayOffDataFirst(result.playeOffFirst);
        setPlayeOffSecond(result.playeOffSecond);
        setPlayeOffFinal(result.playeOffFinal);
        setPlayOffMatch1(result?.playerOffOneData.playOffMatch1);
        setPlayOffMatch2(result?.playerOffOneData.playOffMatch2);
        setPlayOffMatch3(result?.playerOffOneData.playOffMatch3);
        setPlayOffMatch4(result?.playerOffOneData.playOffMatch4);
        setPlayOffMatch5(result?.playerOffOneData.playOffMatch5);
        setGroup1Rank2Data(result?.group1Rank2Data);
        setGroup1Rank3Data(result?.group1Rank3Data);
        setGroup2Rank3Data(result?.group2Rank3Data);
        setGroup2Rank2Data(result?.group2Rank2Data);
        setRankingData(result?.rankingData);
        setRoundDetails(result.roundDetails);
      }
    });
    if (playOffNumber === 1) {
      setIsPlayOffModalOpen(!isPlayOffModalOpen);
    }
    if (playOffNumber === 2) {
      setIsPlayOffModalOpen2(!isPlayOffModalOpen2);
    }
    if (playOffNumber === 3) {
      setIsPlayOffModalOpenFinal(!isPlayOffModalOpenFinal);
    }
  };

  return (
    <>
      <table className="main-table4 table innertable">
        <thead>
          <tr>
            <th scope="col">Playoff</th>
            <th scope="col">Duration</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          {props.playOffListing &&
            props.playOffListing.map((item, key) => (
              <tr key={key}>
                <td>
                  {item?.play_off_number === 3 ? (
                    <span>Final</span>
                  ) : (
                    <span>Playoff {item?.play_off_number}</span>
                  )}
                </td>
                <td>
                  R{item?.round}&nbsp;({moment(item.start_date).format("MMM D")}
                  -{moment(item.end_date).format("MMM D")})
                </td>

                <td>
                  <Link
                    size="sm"
                    onClick={() => handlePlayOffShow(item?.play_off_number)}
                    className="more_link"
                    style={{ color: "white" }}
                  >
                    View H2H
                  </Link>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      <ShowPlayOff
        isPlayOffModalOpen={isPlayOffModalOpen}
        setIsPlayOffModalOpen={setIsPlayOffModalOpen}
        playOffDataFirst={playOffDataFirst}
        playOffMatch1={playOffMatch1}
        playOffMatch2={playOffMatch2}
        rankingData={rankingData}
        roundDetails={roundDetails}
      />
      <ShowPlayOff2
        isPlayOffModalOpen2={isPlayOffModalOpen2}
        setIsPlayOffModalOpen2={setIsPlayOffModalOpen2}
        playeOffSecond={playeOffSecond}
        playOffMatch1={playOffMatch1}
        playOffMatch2={playOffMatch2}
        playOffMatch3={playOffMatch3}
        playOffMatch4={playOffMatch4}
        rankingData={rankingData}
        roundDetails={roundDetails}
      />
      <ShowPlayOffFinal
        isPlayOffModalOpenFinal={isPlayOffModalOpenFinal}
        setIsPlayOffModalOpenFinal={setIsPlayOffModalOpenFinal}
        playOffMatch3={playOffMatch3}
        playOffMatch4={playOffMatch4}
        playeOffFinal={playeOffFinal}
        playOffMatch5={playOffMatch5}
        roundDetails={roundDetails}
      />
    </>
  );
};

export default H2HPlayOff;
